import type { ReactNode } from 'react';
import { Text } from '@querodelivery/uni-react';
import styles from './tag.module.scss';

interface TagProps {
  children: ReactNode;
  highlight?: boolean;
}

export function Tag({ children, highlight }: TagProps) {
  return (
    <span className={styles.tag} data-highlight={highlight}>
      <Text
        as="span"
        fontSize="sm"
        fontWeight={highlight ? 'semibold' : 'regular'}
        lineHeight="default"
        tone="inherit"
      >
        {children}
      </Text>
    </span>
  );
}
